import produce from 'immer';

const INITIAL_STATE = {
  isSearchOpen: false,
  searchText: '',
  cameraType: 'front',
  qrCodeCameraType: 'front',
};

export default function settings(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@settings/TOGGLE_SEARCH': {
        draft.isSearchOpen = !state.isSearchOpen;
        break;
      }
      case '@settings/CHANGE_SEARCH_TEXT': {
        draft.searchText = action.payload;
        break;
      }
      case '@settings/CHANGE_CAMERA_TYPE': {
        draft.cameraType = action.payload;
        break;
      }
      case '@settings/CHANGE_QRCODE_CAMERA_TYPE': {
        draft.qrCodeCameraType = action.payload;
        break;
      }
      default:
    }
  });
}
